import axios from "axios";
import env from "../../env";

const api = axios.create({
  baseURL: env.HR(),
});

// Dev tunnel services (ngrok, localtunnel, Cloudflare Tunnel...) hand out
// random subdomain.host.tld addresses for local testing — same shape as a
// real subdomain.company.com tenant URL, so without this list every one of
// them gets misread as a tenant name (e.g. "teaching-elf-skilled" from
// teaching-elf-skilled.ngrok-free.app), silently breaking every tenant-scoped
// request (login, profile fetch...) for whoever is testing through a tunnel.
const DEV_TUNNEL_SUFFIXES = [
  ".ngrok-free.app",
  ".ngrok.app",
  ".ngrok.io",
  ".loca.lt",
  ".trycloudflare.com",
];

// Extract tenantId from subdomain
const getTenantId = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  // For plain localhost or IP addresses, return null
  if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  if (DEV_TUNNEL_SUFFIXES.some((suffix) => hostname.endsWith(suffix))) {
    return null;
  }

  // Handle subdomain.localhost (e.g., momen.localhost)
  if (parts.length === 2 && parts[1] === "localhost") {
    return parts[0];
  }

  // Handle subdomain.domain.com (e.g., tenant.example.com)
  if (parts.length > 2) {
    return parts[0];
  }

  return null;
};

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const T = localStorage.getItem("Nannotoken");
    if (T) {
      const token = atob(T);
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (getTenantId() !== "demo-ns-hr" && getTenantId() !== null) {
      // Add tenantId header
      config.headers["tenantId"] = getTenantId();
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
